import controller from './payWithPaypal.controller';
import template from './payWithPaypal.html';

const PayWithPaypalDetailsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default PayWithPaypalDetailsComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/payWithPaypal/payWithPaypal.component.js
 **/